module.exports = __webpack_public_path__ + "img/cy.0a4667f9.svg";